import {
	StorageSerializers,
	useSessionStorage,
	useLocalStorage,
	type MaybeRefOrGetter
} from "@vueuse/core";

const STORAGE_KEYS = {
	IMPERSONATION_HISTORY: "impersonationHistory",
	IMPERSONATE_USER: "impersonatedUser"
} as const;

export type UserObject = {
	id: string;
	email: string;
	fullName?: string;
	startDate: string;
	endDate?: string;
};

type StorageDataByKey = {
	impersonationHistory: UserObject[];
	impersonatedUser: UserObject | null;
};

type StorageData<T> = T extends keyof StorageDataByKey
	? StorageDataByKey[T]
	: never;

export function useAppSessionStorage<T extends keyof typeof STORAGE_KEYS>(
	key: T,
	defaultValue: MaybeRefOrGetter<StorageData<(typeof STORAGE_KEYS)[T]>>,
	useObjectSerializer: boolean = false
) {
	const serializer = useObjectSerializer
		? { serializer: StorageSerializers.object }
		: {};
	const storedValue = useSessionStorage<
		StorageData<(typeof STORAGE_KEYS)[T]>
	>(STORAGE_KEYS[key], defaultValue, { ...serializer });
	return storedValue;
}
export function useAppLocalStorage<T extends keyof typeof STORAGE_KEYS>(
	key: T,
	defaultValue: MaybeRefOrGetter<StorageData<(typeof STORAGE_KEYS)[T]>>,
	useObjectSerializer: boolean = false
) {
	const serializer = useObjectSerializer
		? { serializer: StorageSerializers.object }
		: {};
	const storedValue = useLocalStorage<StorageData<(typeof STORAGE_KEYS)[T]>>(
		STORAGE_KEYS[key],
		defaultValue,
		{ ...serializer }
	);
	return storedValue;
}
